import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b18761c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "list-title" }
const _hoisted_3 = { class: "tab-list" }
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "first" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { key: 0 }

import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getBlockNumber, getChain } from "@/api/_common";
import Title from "@/components/SecondaryTitle.vue";
import List from "@/components/List.vue";
import Summary from "./summary.vue";
import { useMq } from "vue3-mq";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const routeName = "Block";
const height = ref(0);
const txsActive = ref(true);
const info = ref({
  Number: 0,
  Time: 0,
  GasUsed: 0,
  GasLimit: 0,
  Difficulty: 0,
});
const txList = ref([]);
const rowData = ref([
  {
    prop: "Rank",
    label: "block.rank",
    method: (row) => row.rank,
  },
  {
    prop: "Hash",
    label: "block.hash",
    method: (row) =>
      isMdOrSmOrXs.value
        ? `${row.hash.slice(0, 8)}...${row.hash.slice(-8)}`
        : row.hash,
  },
]);

const route = useRoute();
const router = useRouter();

const getBlockHeight = async () => {
  const res = await getChain();
  if (res) {
    height.value = res.Height;
  }
};
const getBlockDetail = async () => {
  const res = await getBlockNumber({
    Number: Number(route.params.Number),
  });
  info.value = res;
  if (res.Transactions) {
    const list = res.Transactions.map((tx, i) => {
      return { hash: tx, rank: i + 1 };
    });
    txList.value = list;
  }
};

const handleRowClick = (row) => {
  router.push({ name: "Tx", params: { Hash: row.hash } });
};

const toBlock = (blockNumber: number) => {
  router.replace({
    params: {
      Number: blockNumber,
    },
  });
};

const load = () => {
  getBlockHeight();
  getBlockDetail();
};
load();

watch(
  () => route.params.Number,
  () => {
    if (router.currentRoute.value.name === routeName) {
      getBlockHeight();
      getBlockDetail();
    }
  }
);

const isMdOrSmOrXs = computed(() => {
  const mq = useMq();
  return mq.current === "md" || mq.current === "sm" || mq.current === "xs";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Title, {
        title: _ctx.$t('block.name')
      }, null, 8, ["title"])
    ]),
    _createVNode(Summary, {
      number: info.value.Number,
      time: info.value.Time,
      gasUsed: info.value.GasUsed,
      gasLimit: info.value.GasLimit,
      difficulty: info.value.Difficulty,
      onPreviousBlock: _cache[0] || (_cache[0] = ($event: any) => (toBlock(info.value.Number - 1))),
      onNextBlock: _cache[1] || (_cache[1] = ($event: any) => (toBlock(info.value.Number + 1))),
      height: height.value
    }, null, 8, ["number", "time", "gasUsed", "gasLimit", "difficulty", "height"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("block.txs")), 1),
            _createElementVNode("div", {
              class: _normalizeClass(txsActive.value ? 'line active' : 'line')
            }, null, 2)
          ])
        ])
      ]),
      (txsActive.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(List, {
              style: {"margin-top":"0","padding":"0"},
              data: txList.value,
              handle: handleRowClick,
              rowDatas: rowData.value,
              total: txList.value.length,
              firstColumnWidth: "180",
              secondColumnWidth: "840"
            }, null, 8, ["data", "rowDatas", "total"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})